import {
    Container,
    Paper,
    Typography,
    Box,
    Button,
    Divider,
    Stack,
    CircularProgress
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
import { Turnstile } from "@marsidev/react-turnstile";
export default function ReviewForm({

    data,
    jobAdvert,
    onBack,
    onSubmit,
    loading,
    turnstileToken,
    setTurnstileToken,
    turnstileError,
    setTurnstileError

}) {

    const { personalDetails, eligibility, documents } = data;

    return (
            <Paper elevation={3} sx={{
                maxWidth: 1200,
                mx: "auto",
                mt: 4,
                mb: 4,
                px: { xs: 2, md: 4 },
                py: 3,
                borderRadius: 2
            }}>

                {/* HEADER */}
                <Typography variant="h4" gutterBottom>
                    Review Your Application
                </Typography>

                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)", }}>
                    Please check your details before submitting your application.
                </Typography>

                {/* JOB TITLE CONTEXT */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6">
                        Applying for:
                    </Typography>

                    <Typography sx={{ fontWeight: 600 }}>
                        {jobAdvert?.jobTitle}
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                {/* PERSONAL DETAILS */}
                <Section title="Personal Details">

                    <Row label="Title" value={personalDetails.title} />
                    <Row label="First Name" value={personalDetails.firstName} />
                    <Row label="Last Name" value={personalDetails.lastName} />
                    <Row label="Email" value={personalDetails.emailAddress} />
                    <Row label="Mobile" value={personalDetails.mobile} />
                    <Row label="Address Line 1" value={personalDetails.addressLine1} />
                    {personalDetails.addressLine2?.trim() && (
                        <Row
                            label="Address Line 2"
                            value={personalDetails.addressLine2}
                        />
                    )}
                    <Row label="Town/City" value={personalDetails.townCity} />
                    <Row label="County" value={personalDetails.county} />
                    <Row label="Postcode" value={personalDetails.postcode} />

                </Section>

                <Divider sx={{ my: 3 }} />

                {/* ELIGIBILITY */}
                <Section title="Eligibility">
                    <Row label="Eligibility Status"  value={eligibility.eligibilityStatus}/>
                    {eligibility.eligibilityStatusOther?.trim() && (
                        <Row
                            label="Eligibility Status Other"
                            value={eligibility.eligibilityStatusOther}
                        />
                    )}
                    <Row
                        label="Salary Range"
                        value={eligibility.salaryRange}
                    />
                    <Row
                        label="CSCS Card"
                        value={eligibility.hasCscsCard ? "Yes" : "No"}
                    />
                    {eligibility.hasCscsCard && eligibility.cscsCardType?.trim() && (
                        <Row
                            label="CSCS Type"
                            value={eligibility.cscsCardType}
                        />
                    )}

                    <Row
                        label="Driving License"
                        value={eligibility.hasDrivingLicence ? "Yes" : "No"}
                    />

                    <Row
                        label="Endorsements"
                        value={eligibility.endorsements ? "Yes" : "No"}
                    />

                    {eligibility.endorsements && eligibility.endorsementsDetails?.trim() && (
                        <Row
                            label="Endorsements Details"
                            value={eligibility.endorsementsDetails}
                        />
                    )}

                </Section>

                <Divider sx={{ my: 3 }} />

                {/* DOCUMENTS */}
                <Section title="Documents">

                    <Row
                        label="CV"
                        value={documents.cv ? documents.cv.name : "Not uploaded"}
                    />

                </Section>

                <Divider sx={{ my: 4 }} />
                {/* Turnstile */}
                <Box sx={{ mb: 4,
                        pointerEvents: loading ? "none" : "auto",
                        opacity: loading ? 0.6 : 1,
                        display: "flex",
                        justifyContent: "center" }}>
                    <Turnstile
                        siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                        onSuccess={(token) => {
                            setTurnstileToken(token);
                            setTurnstileError("");
                        }}
                        onExpire={() => {
                            setTurnstileToken(null);
                        }}
                        onError={() => {
                            setTurnstileToken(null);
                            setTurnstileError("Verification failed. Please try again.");
                        }}
                    />

                    {turnstileError && (
                        <Typography
                            color="error"
                            textAlign="center"
                            sx={{ mb: 3 }}
                        >
                            {turnstileError}
                        </Typography>
                    )}
                </Box>

                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    justifyContent="space-between"
                >
                    <Button
                        variant="contained"
                        onClick={onBack}
                        disabled={loading}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>

                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        disabled={loading || !turnstileToken}
                        sx={{ minWidth: 220, textTransform: 'none' }}
                        onClick={onSubmit}
                        startIcon={
                            loading ? (
                                <CircularProgress
                                    size={18}
                                    color="inherit"
                                />
                            ) : null
                        }
                    >
                        {loading ? "Submitting..." : "Submit Application"}
                    </Button>
                </Stack>

            </Paper>

    );

}

/* ---------------------------- */
/* Helper Components */
/* ---------------------------- */

function Section({ title, children }) {

    return (

        <Box sx={{ mb: 2 }}>

            <Typography variant="h6" sx={{ mb: 2 }}>
                {title}
            </Typography>

            <Box sx={{ display: "grid", gap: 1 }}>
                {children}
            </Box>

        </Box>

    );

}

function Row({ label, value }) {

    return (

        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "180px 1fr"
                },
                gap: 1.5,
                mb: 1
            }}
        >

            <Typography sx={{ fontWeight: 600 }}>
                {label}
            </Typography>

            <Typography
                sx={{
                    minWidth: 0,
                    overflowWrap: "anywhere",
                    wordBreak: "break-word"
                }}
            >
                {value || "-"}
            </Typography>

        </Box>

    );

}